import { format, parse } from '@legacy/js/date/date-fns.js';

export default class BatchMemberClassification {
    constructor() {
        this.action = 'ClassificationAssignment';
        this.entity = 'ClubMember';
        this.start = null;
        this.end = null;
        this.notice = null;
    }

    serialize() {
        const start = parse(this.start, 'dd.MM.yyyy', new Date());
        const end = this.end === null ? null : parse(this.end, 'dd.MM.yyyy', new Date());
        return {
            action: this.action,
            entity: this.entity,
            ids: this.ids,
            classificationId: this.classification?.id,
            start: format(start, 'dd.MM.yyyy'),
            end: end === null ? null : format(end, 'dd.MM.yyyy'),
            notice: this.notice,
        };
    }

    isValid() {
        if (!this.classification) {
            return false;
        }
        if (!this.start) {
            return false;
        }
        if (!this.ids || this.ids.length === 0) {
            return false;
        }
        return true;
    }
}
